var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPecrList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603,
    y: 367,
    width: 288,
    height: 288
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-603 -367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M738 442 807 442 807 448 738 448Z",
    stroke: "#152C73",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738 487 807 487 807 493 738 493Z",
    stroke: "#152C73",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738 532 807 532 807 538 738 538Z",
    stroke: "#152C73",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738 577 807 577 807 583 738 583Z",
    stroke: "#152C73",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657 631 837 631 837 391 657 391ZM663 397 831 397 831 625 663 625Z",
    stroke: "#152C73",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687 458.5 714 458.5 714 431.5 687 431.5ZM693 437.5 708 437.5 708 452.5 693 452.5Z",
    stroke: "#152C73",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687 503.5 714 503.5 714 476.5 687 476.5ZM693 482.5 708 482.5 708 497.5 693 497.5Z",
    stroke: "#152C73",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687 548.5 714 548.5 714 521.5 687 521.5ZM693 527.5 708 527.5 708 542.5 693 542.5Z",
    stroke: "#152C73",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687 593.5 714 593.5 714 566.5 687 566.5ZM693 572.5 708 572.5 708 587.5 693 587.5Z",
    stroke: "#152C73",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPecrList);
export default __webpack_public_path__ + "static/media/PECR List.f186cd07d5b59f0196fd3d7992c785c7.svg";
export { ForwardRef as ReactComponent };